<template>
    <div class="page">
        <transition name="fade-transition">
            <v-container v-if="teacher" :class="{'py-3 px-0': phoneOnly, 'py-6': pcOnly}">
                <div class="py-6 py-lg-8 px-5 rounded lg:bordered mb-2 mb-lg-8">
                    <div class="d-flex flex-column align-center">
                        <v-avatar :size="pcOnly ? 80 : 80" rounded class="bordered mb-3">
                            <v-img :src="teacher.avatar"></v-img>
                        </v-avatar>
                        <div class="text-center">
                            <div class="strong-text--text font-weight-semibold mb-5" style="font-size: 18px">{{teacher.name}}</div>
                            <div class="details-text muted--text font-weight-semibold mb-3">روابط التواصل</div>
                            <div class="d-flex align-center justify-center">
                                <v-btn as="a" v-for="item in contactItems" icon :href="item.href" :target="capRunning ? '_system' : '_blank'" :color="item.color" outlined :key="item.name" class="mx-1">
                                    <v-icon>{{item.icon}}</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="teacher.banner" class="mb-6 lg:bordered rounded-lg overflow-hidden mx-4 mx-md-0">
                    <v-img :src="teacher.banner" :height="pcOnly ? 350 : 150"></v-img>
                </div>
                <div>
                    <div v-if="phoneOnly" class="px-12 mb-5 mt-2">
                        <v-divider class="mx-auto"></v-divider>
                    </div>
                    <div v-if="courses && courses.length">
                        <v-row v-if="pcOnly">
                            <v-col cols="12" md="6" lg="3" v-for="(course, i) in courses" :key="course.id + '-' + i" class="px-0 px-md-2 py-2">
                                <course-card short :course="course"> </course-card>
                            </v-col>
                        </v-row>
                        <v-list v-else two-line class="pa-0">
                            <course-list-item v-for="(course, i) in courses" :key="course.id + '-' + i" :course="course" />
                        </v-list>
                    </div>
                    <div v-else class="pa-4 pa-lg-0">
                        <v-alert outlined color="blue-grey" text type="info">
                            <div class="medium-text">لا يوجد دورات للمحاضر {{teacher.name}} حتى اﻵن</div>
                        </v-alert>
                    </div>
                </div>
                
            </v-container>
        </transition>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import CourseCard from '@/components/custom/course-card'
import CourseListItem from '@/components/custom/course-list-item'

export default {
    name: "Courses",
    components: {
        CourseCard,
        CourseListItem
    },
    data(){
        return {
            teacher: null,
            courses: null,
            loading: false,
        }
    },
    computed: {
        ...GlobalComputed,
        id(){
            return this.$route.params.id;
        },
        contactItems(){
            const teacher = this.teacher;
            if (teacher){
                let socialItems = [
                    {name: 'phone', icon: 'mdi-phone', color: 'primary', href: teacher.phone ? `tel:${teacher.phone}` : null},
                    {name: 'email', icon: 'mdi-email-outline', color: 'primary', href: teacher.email ? `mailto:${teacher.email}` : null},

                    {name: 'whatsapp', icon: 'mdi-whatsapp', color: 'green darken-1', href: teacher.whatsapp_url},
                    {name: 'facebook', icon: 'mdi-facebook', color: 'indigo darken-1', href: teacher.facebook_url},
                    {name: 'messenger', icon: 'mdi-facebook-messenger', color: 'blue darken-1', href: teacher.messenger_url},
                    {name: 'twitter', icon: 'mdi-twitter', color: 'blue darken-1', href: teacher.twitter_url},
                    {name: 'youtube', icon: 'mdi-youtube', color: 'red darken-1', href: teacher.youtube_url},
                    {name: 'telegram', icon: 'mdi-telegram', color: 'blue darken-2', href: teacher.telegram_url},
                ];
                return socialItems.filter(item=>!!item.href);
            }
            return [];
        },
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
        id(id){
            this.getTeacherData();
        }
    },
    methods: {
        ...GlobalMethods,
        getTeacherData(){
            if (!this.loading){
                this.loading = true;
                this.$store.dispatch('fastGetAction', {url: `/teachers/${this.id}`}).then(response=>{
                    this.loading = false;
                    this.teacher = response.data.teacher;
                    this.courses = response.data.courses;
                    
                    this.setDocumentTitle(this.teacher.name, true);

                }).catch(()=>{
                    this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    this.loading = false;
                });
            }
        },
    },
    mounted(){
        this.getTeacherData();
    }
};
</script>

<style lang="scss">
.v-skeleton-loader__image{
    height: 150px!important;
}
</style>